module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0096.jpg?v=301f8047";